module.exports = __webpack_public_path__ + "static/media/floor_se2.d06214f0.png";